<div class="modal-header pb-0 border-0 d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center" style="gap: 10px;">
        <div class="header-icon-wrapper">
            <iconify-icon icon="clarity:store-solid" width="22" height="22" style="color:#fff;"></iconify-icon>
        </div>
        <h1 class="modal-title font-weight-bold font-agrandir m-0 modal-heading" style="color:#000;">
            Merchants List
        </h1>
    </div>
    <button type="button" class="close" style="color:#000;" (click)="modalRef.hide()">
        <iconify-icon icon="ic:round-close" width="26" height="26"></iconify-icon>
    </button>
</div>

<hr class="mt-2 mb-0 opacity-100" style="background-color: #CCCCCC; border: solid 2px #CCCCCC;">

<div class="modal-body">
  <div class="table-responsive">
    <table class="table align-items-center table-flush">
      <thead class="thead-light font-agrandir">
        <tr>
          <th scope="col">Merchant Name</th>
          <th scope="col">Legal Name</th>
          <th scope="col">Description</th>
          <th scope="col">Invoice Prefix</th>
          <th scope="col">Status</th>
          <th scope="col">Registration Type</th>
          <th scope="col">Registration Number</th>
          <th scope="col">Creation Date</th>
        </tr>
      </thead>
      <tbody class="font-bricolage">
        <tr *ngFor="let merchant of merchants">
          <td>{{ merchant.merchantName }}</td>
          <td>{{ merchant.legalName }}</td>
          <td class="td-expand-hover"
              [class.expanded]="expandedCell === merchant.merchantName"
              (click)="expandedCell = expandedCell === merchant.merchantName ? null : merchant.merchantName">
            {{ merchant.description }}
          </td>
          <td>{{ merchant.invoicePrefix }}</td>
          <td>{{ merchant.status }}</td>
          <td>{{ merchant.registrationType }}</td>
          <td>{{ merchant.registrationNumber }}</td>
          <td>{{ formatTimestamp(merchant.creationDate) }}</td>
        </tr>
        <tr *ngIf="isLoading">
          <td colspan="8" class="text-center" style="height: 160px; vertical-align: middle; color:#000;">
            Loading...
          </td>
        </tr>
        <tr *ngIf="!isLoading && merchants.length === 0">
          <td colspan="8" class="text-center" style="height: 160px; vertical-align: middle; color:#000;">
            No sub-merchants found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer"></div>